"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
const react_1 = __importDefault(require("react"));
const use_field_api_1 = __importDefault(require("@data-driven-forms/react-form-renderer/use-field-api"));
const react_form_renderer_1 = require("@data-driven-forms/react-form-renderer");
const FormField_1 = __importDefault(require("../../../FormField"));
const Text_1 = __importDefault(require("../../../Text"));
const Button_1 = __importDefault(require("../../../Button"));
const Stack_1 = __importDefault(require("../../../../layouts/Stack"));
const FieldArrayItem_1 = __importDefault(require("./components/FieldArrayItem"));
const getErrorText_1 = require("../../utils/getErrorText");
const useUniqueId_1 = __importDefault(require("../../../../hooks/useUniqueId"));
const DEFAULT_BUTTON_LABELS = {
    add: 'Add new item',
    remove: 'Remove',
};
const FieldArrayMapping = (props) => {
    const { arrayValidator, label, description, helperText, fields: formFields, defaultItem = {}, showError, meta: { submitFailed, error }, layout, minItems = 0, maxItems = Number.MAX_SAFE_INTEGER, buttonLabels, noItemsMessage, validateOnMount, input, isReadOnly = false, } = use_field_api_1.default(props);
    const controlId = useUniqueId_1.default(input.name);
    const errorText = getErrorText_1.getErrorText(validateOnMount, submitFailed, showError, error);
    const renderedButtonLabels = Object.assign(Object.assign({}, DEFAULT_BUTTON_LABELS), buttonLabels);
    return (react_1.default.createElement(FormField_1.default, { controlId: controlId, label: label, description: description, hintText: helperText, errorText: errorText },
        react_1.default.createElement(react_form_renderer_1.FieldArray, { key: controlId, name: controlId, validate: arrayValidator }, ({ fields }) => {
            const { length, map, push, remove } = fields;
            return (react_1.default.createElement(Stack_1.default, { spacing: "s" },
                length === 0 && react_1.default.createElement(Text_1.default, null, noItemsMessage),
                map((name, index) => {
                    return (react_1.default.createElement(FieldArrayItem_1.default, { layout: layout, key: name, fields: formFields, name: name, fieldIndex: index, showError: showError, onRemove: remove, length: length, minItems: minItems, removeLabel: renderedButtonLabels.remove, isReadOnly: isReadOnly }));
                }),
                !isReadOnly && (react_1.default.createElement(Button_1.default, { onClick: () => push(defaultItem), disabled: !!length && length >= maxItems }, renderedButtonLabels.add))));
        })));
};
exports.default = FieldArrayMapping;
//# sourceMappingURL=index.js.map